import { lazy } from 'react'

export const TopPriorityVariant1 = lazy(() => import('./TopPriorityVariant1'))
